import RandingStyle22 from "../../randing/RandingStyle22";

function Randing293({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle22
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/293/01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/293/02.jpg`}
        formFieldColor="white"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/293/03.png`}
        companyName="본원"
        fixedDbColor="rgba(255, 255, 255, 0.8)"
        articleOption={true}
        benefitInfo={false}
        btnSize22={true}
      />
    </>
  );
}

export default Randing293;
